import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, toRefs, useContext, watch } from '@nuxtjs/composition-api';
import { useMobile } from '~/core/composables/useMobile';
import { ACTIONS as TERMS_AND_CONDITIONS_ACTIONS } from '~/store/affility/user/flows/terms-and-conditions/names';
import { ACTIONS as UPGRATE_TO_AFFILIATE_ACTIONS } from '~/store/affility/user/flows/upgrade-to-affiliate/names';

interface Props {
    visible: boolean,
    isEligibleForFreeAutoship: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UpgradeToAffiliatePrompt',
  props: {
    visible: { type: Boolean },
    isEligibleForFreeAutoship: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { visible: boolean, isEligibleForFreeAutoship: boolean };

const { store } = useContext();
const isMobile = useMobile();
const buttonSize = computed(() => isMobile.value ? 's' : 'm');
const buttonsReversed = computed(() => isMobile.value);
const buttonsDirection = computed(() => isMobile.value ? 'column' : 'row');



const {
    visible,
    isEligibleForFreeAutoship,
} = toRefs(props);

const error = ref('');
const isRequesting = ref(false);
const haveReadTerms = ref(false);

const internalVisible = ref(visible.value);
watch(visible, (value) => {
    internalVisible.value = value;
});
watch(internalVisible, (value) => {
    if (!value) {
        haveReadTerms.value = false;
        error.value = '';
        isRequesting.value = false;
        cancelUpgrade();
    }
});

const productAutoshipText = computed(() => {
    if (isEligibleForFreeAutoship.value) {
        return 'upgrade_to_affiliate_description_free_autoship';
    }
    return 'upgrade_to_affiliate_description_mandatory_autoship';
});

const showTermsAndConditionsPopup = store.dispatch.bind(null, `affility/user/flows/terms-and-conditions/${TERMS_AND_CONDITIONS_ACTIONS.OPEN_AFFILIATE_TERMS_AND_CONDITIONS}`, { acceptable: false });

const cancelUpgrade = store.dispatch.bind(null, `affility/user/flows/upgrade-to-affiliate/${UPGRATE_TO_AFFILIATE_ACTIONS.CANCEL_UPGRADE_TO_AFFILIATE}`);
const confirmUpgrade = async () => {
    error.value = '';
    isRequesting.value = true;
    try {
        await store.dispatch(`affility/user/flows/upgrade-to-affiliate/${UPGRATE_TO_AFFILIATE_ACTIONS.UPGRADE_TO_AFFILIATE_UPDATE_USER_AND_SHOW_NOTIFICATION}`);
    } catch (err) {
        console.warn(err);
        error.value = 'Oops...Something went wrong. Please try again';
    } finally {
        isRequesting.value = false;
    }
};


return { __sfc: true,store, isMobile, buttonSize, buttonsReversed, buttonsDirection, props, visible, isEligibleForFreeAutoship, error, isRequesting, haveReadTerms, internalVisible, productAutoshipText, showTermsAndConditionsPopup, cancelUpgrade, confirmUpgrade }
}

})